import { Icons, Progress, Spinner, Text } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { refetchFunc } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import FormSelectShared from 'views/components/FormSelectShared'

export const ParentCompanyBlock = ({
  companyId,
  parentId,
  refetch,
}: {
  companyId: number
  parentId?: number
  refetch: refetchFunc
}) => {
  const { t } = useTranslation('user')
  const { formHandler, formProgress } = useAFormHandler()
  const [addMode, setAddMode] = useState(!!parentId)

  const formik = useFormik<{ parent?: string }>({
    initialValues: {
      parent: parentId ? parentId.toString() : undefined,
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.patch(endpoints.company(companyId), { parent: formik.values.parent })
      },
      {
        onSuccess: refetch,
      },
    ),
  })

  useEffect(() => {
    if (formik.values.parent === parentId?.toString()) return
    formik.submitForm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.parent])

  if (!addMode) {
    return (
      <>
        <Text color="secondary">{t('mainCompany')}</Text>
        <div>
          <AButton id="add-parent-company" color="approve" Icon={Icons.IconAdd} onClick={() => setAddMode(true)}>
            {t('bindWithParentCompany')}
          </AButton>
        </div>
      </>
    )
  }
  return (
    <>
      <div style={{ display: 'flex', gap: '10px' }}>
        <Text color="secondary">{t('mainCompany')}</Text>
        {formProgress === Progress.WORK && <Spinner size="small" />}
      </div>
      <FormSelectShared
        hideLabel
        endpoint={`${endpoints.company()}?parents_only=True`}
        formik={formik}
        fieldName="parent"
        placeholder=""
        searchField="search"
      />
    </>
  )
}
